import React, { useContext, useEffect, useState } from 'react'
import Style from './index.module.css'
import { toast } from "react-toastify";
import authInstance from '../../../instance/AuthInstance';
import { HiOutlineViewfinderCircle } from 'react-icons/hi2';
import { Link, useNavigate } from 'react-router-dom'
import { AiFillHeart, AiOutlineDelete } from 'react-icons/ai';
import { PiCurrencyInrBold } from "react-icons/pi";
import { UserContext } from '../../../Contexts/UserContext';
import { FaRocket, FaClock } from "react-icons/fa";

const OwnCard = ({ product, reloadProducts, boostStats, handleBoost }) => {

    const LoggedInUser = useContext(UserContext);
    const { User } = LoggedInUser

    const Navigate = useNavigate()

    const [IsClicked, SetIsClicked] = useState(false);
    const [WishlistData, SetWishlistData] = useState([]);


    //Load whishlist product functions
    useEffect(() => {
        try {
            authInstance.get(`/api/user/wishlist/get_wishlist/${User?._id}`).then((Response) => {
                SetWishlistData(Response.data)
            }).catch((err) => {
                console.log(err);
            })
        } catch (error) {
            console.log(error);
        }
    }, [User?._id]);

    //check weather these product in wishlist
    const findItemId = () => {
        WishlistData.forEach((Data) => {
            const item = Data?.wishlist
            const foundItem = item.find(item => item?._id === product?._id)
            if (foundItem) {
                SetIsClicked(true)
            } else {
                SetIsClicked(false)
            }
        })
    }

    useEffect(() => {
        findItemId();
    }, [WishlistData]);

    // To put product into whishlist
    const handleFavorite = (e) => {
        e.preventDefault();
        try {
            authInstance.post('/api/user/wishlist/add_wishlist', { userId: User?._id, productId: product?._id }).then((Response) => {
                toast.success("Product Added to Wishlist")
                SetIsClicked(true)
            }).catch((err) => {
                Navigate('/registration_login')
                console.log(err);
            })
        } catch (error) {
            console.log(error);
        }
    }

    //Delete from wishlist
    const handleFavoriteDelete = (e) => {
        e.preventDefault()
        try {
            authInstance.delete(`/api/user/wishlist/remove_wishlist/${User?._id}/${product?._id}`).then((Response) => {
                toast.success("Product removed from Wishlist")
                SetIsClicked(false)
            }).catch((err) => {
                console.log(err);
            })
        } catch (error) {
            console.log(error);
        }
    };

    // -- Remove Product 
    const HandleRemove = (e) => {
        e.preventDefault()
        try {
            authInstance.delete(`/api/user/product/product_sold?userId=${User?._id}&productId=${product?._id}`).then((Response) => {
                toast.success("Product removed");
                reloadProducts();
            }).catch((err) => {
                console.log(err);
            })
        } catch (error) {
            console.log(error);
        }
    }

    const getBoostTimeAgo = (dateString) => {
        if (!dateString) return "";
        const now = new Date();
        const boostedDate = new Date(dateString);
        const diffInSeconds = Math.floor((now - boostedDate) / 1000);

        if (diffInSeconds < 60) return "Just now";
        if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
        if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
        return `${Math.floor(diffInSeconds / 86400)}d ago`;
    };

    const isVerifiedSeller = product?.userId?.emailVerified && product?.userId?.phoneVerified;

    return (
        <div className={`${Style.products} ${(product?.isBoosted || product?.boosted) ? Style.boostedProduct : isVerifiedSeller ? Style.verifiedProductCard : ''}`} >

            <div className={Style.productmedia}>
                {(product?.isBoosted || product?.boosted) && (
                    <span className={Style.boostBadge}>
                        <FaRocket /> Recommended
                    </span>
                )}
                {product?.featured ?
                    <span className={Style.productlabel}>Featured</span>
                    : null
                }

                <Link to={`/product/${product?._id}`} >
                    <img src={product?.images[0].url} alt="productImage" className={Style.productImage} />
                </Link>
                <div className={Style.productAction}>
                    {/* Only show boost button if user owns it (which is true in OwnCard) */}
                    {User?._id === product?.userId && !(product?.isBoosted || product?.boosted) && boostStats?.boostsRemaining > 0 && (
                        <span onClick={(e) => {
                            e.preventDefault();
                            handleBoost(product._id);
                        }} className={Style.boostBtn}>
                            <i style={{ color: '#FF6B35' }}> <FaRocket /> </i> Boost
                        </span>
                    )}

                    {User?._id === product?.userId ?
                        <span onClick={(e) => HandleRemove(e)} >
                            <i><AiOutlineDelete /></i> Remove
                        </span> :
                        <span onClick={(e) => IsClicked ? handleFavoriteDelete(e) : handleFavorite(e)} >
                            <i style={{ color: IsClicked ? 'red' : 'grey' }} ><AiFillHeart /></i> Favorite
                        </span>
                    }
                    <span onClick={() => Navigate(`/product/${product._id}`)}> <i><HiOutlineViewfinderCircle /></i> Explore </span>
                </div>
            </div>
            <div className={Style.productbody}>
                <div className={Style.product_cat}>
                    <span> {product?.state} </span>
                    {(product?.isBoosted || product?.boosted) && (
                        <span className={Style.boostTime}>
                            <FaClock /> {getBoostTimeAgo(product.boostedAt)}
                        </span>
                    )}
                </div>
                <div className={Style.product_title}>
                    <h3> {product?.title} </h3>
                </div>
                <div className={Style.product_price}>
                    <PiCurrencyInrBold /> {product?.price}
                </div>
            </div>
        </div>
    )
}

export default OwnCard